export const PATH = {
  LOGIN: 'auth/credentials',
  LOGOUT: 'auth/logout',
  REGISTRATION: 'registration/register',
  MIGRATION: 'migration/register',
  CHECK_REGISTRATION_CODE: 'registration/init',
  CHECK_MIGRATION_CODE: 'migration/init',
  SEND_VERIFICATION_CODE_REQUEST: 'registration/sendVerificationCode',
  SEND_REGISTRATION_CODE_REQUEST: 'registration/sendRegistrationCode',
  CONFIRM_VERIFICATION_CODE: 'registration/confirmAccount',
  RESET_PASSWORD: 'registration/resetPassword',
  USER_INFO: 'auth/info',
  GET_COMPANY_INFO: 'company',
  VERIFY_EMAIL: 'registration/verifyEmail',
  CONFIRM_REGISTRATION: 'registration/confirmSelfRegisteredAccount',
}

export const ACCOUNT_STATUSES = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  REGISTERED: 'Registered',
}

export const REGISTRATION_STATUSES = {
  REVIEW: 'InReview',
  INCOMPLETE: 'Incomplete',
  REQUESTED: 'Requested',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  COMPLETE: 'Complete',
}

export const READONLY_STATUSES = [
  REGISTRATION_STATUSES.REVIEW,
  REGISTRATION_STATUSES.APPROVED,
]
